<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<form [formGroup]="beerPongTableForm" (ngSubmit)="updateBeerPongTable()">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Update Beer Pong Table</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput type="text" formControlName="name" name="name" />
        @if (
          beerPongTableForm.controls.name.invalid &&
          beerPongTableForm.controls.name.errors?.['required']
        ) {
          <mat-error>Name is required.</mat-error>
        }
        @if (
          beerPongTableForm.controls.name.invalid &&
          beerPongTableForm.controls.name.errors?.['pattern']
        ) {
          <mat-error> Name contains characters that aren't allowed.</mat-error>
        }
        @if (
          beerPongTableForm.controls.name.invalid &&
          beerPongTableForm.controls.name.errors?.['minlength']
        ) {
          <mat-error> Name needs to be at least 3 characters long.</mat-error>
        }
        @if (
          beerPongTableForm.controls.name.invalid &&
          beerPongTableForm.controls.name.errors?.['maxlength']
        ) {
          <mat-error> Name can't be more than 20 characters.</mat-error>
        }
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions>
      <a
        mat-button
        [disabled]="this.beerPongTableForm.disabled"
        [routerLink]="'../..'"
        color="warn"
        style="margin-right: var(--spacing2)"
      >
        Cancel
      </a>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="this.beerPongTableForm.disabled"
        id="update-beer-pong-table"
      >
        Update
      </button>
    </mat-card-actions>
  </mat-card>
</form>
